import { buildCampaignSuperProperties } from './campaignAttribution';

/**
 * The Mixpanel super properties registered once per app session. Everything here
 * rides along on every subsequent event, so a call site never has to remember to
 * pass the platform or the acquiring channel.
 */

export interface AppSuperPropertiesInput {
  /** Platform.OS — campaign attribution only exists on web. */
  platform: string;
  appVersion: string;
  appEnv: string;
  locale: string;
}

export function buildAppSuperProperties(input: AppSuperPropertiesInput): Record<string, unknown> {
  const props: Record<string, unknown> = {
    platform: input.platform,
    app_version: input.appVersion,
    app_env: input.appEnv,
    locale: input.locale,
  };

  // A native install has no URL to read a campaign from. Merging campaign props
  // there would register a `direct` channel on every mobile user, which reads as
  // a measurement rather than the absence of one.
  if (input.platform === 'web') {
    Object.assign(props, buildCampaignSuperProperties());
  }

  return props;
}
